import { Drawer, Grid, Typography } from '@mui/material';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { GlobalFilterTypeHandle } from '../../../context/types';
import { Filter } from '../filter/filterbar/types';
import { FilterTray } from '../filter/filtertray/FilterTray';
import { FilterSection } from '../filter/types';
import { State } from './types';

const StyledDrawer = styled(Drawer)<{ $backgroundColor: string }>`
  width: 250px;
  flex-shrink: 0;

  & .paper {
    width: 250px;
    background: ${(props) => props.$backgroundColor};
  }
  & .paper1 {
    width: 250px;
    background: ${(props) => props.$backgroundColor};
  }
`;

const StyledTypography = styled(Typography)<{ $backgroundColor: string }>`
  z-index: 9999;
  position: sticky;
  top: 0;
  color: white;
  background: ${(props) => props.$backgroundColor};
  border-bottom: 2px solid white;
  text-align: center;
  padding: 12px 16px;
  text-transform: uppercase;
`;

interface FilterDrawerProps<S extends State, FS extends FilterSection> {
  opened: S;
  setClosed: () => void;
  isFullScreen: boolean;
  filterSections: FS[];
  filterHandle: GlobalFilterTypeHandle<Filter>;
  keyPrefix: string;
  options: {
    mainBackgroundColor: string;
    backgroundColors: string[];
    titleKey: string;
    myFilters?: { enabled?: boolean };
  };
}

export const FilterDrawer = <S extends State, FS extends FilterSection>(
  props: FilterDrawerProps<S, FS>
) => {
  const { t } = useTranslation();
  const {
    opened,
    setClosed,
    isFullScreen,
    filterSections,
    filterHandle,
    options,
  } = props;
  const globalSearchRef = useRef<HTMLInputElement>();

  return (
    <StyledDrawer
      anchor="left"
      open={opened !== 'closed'}
      onClose={setClosed}
      classes={{ paper: 'paper1' }}
      variant={isFullScreen ? 'persistent' : 'temporary'}
      PaperProps={{
        sx: { width: '250px', willChange: 'auto' },
      }}
      keepMounted={true}
      $backgroundColor={options.mainBackgroundColor}
    >
      <StyledTypography $backgroundColor={options.mainBackgroundColor}>
        {t(options.titleKey)}
      </StyledTypography>
      <Grid container>
        <FilterTray<FS>
          filterSections={filterSections}
          filterHandle={filterHandle}
          options={{
            backgroundColors: options.backgroundColors,
            myFilters: options.myFilters,
          }}
          globalSearchRef={globalSearchRef}
        />
      </Grid>
    </StyledDrawer>
  );
};
